import { SecretProps } from "@hightouch/formkit";
import { Controller } from "react-hook-form";
import { SecretInput } from "src/components/secret-input";
import { SharedProps } from ".";

export const FKSecret = ({
  name,
  isSetup,
  multiline,
  placeholder,
  isDisabled,
}: SecretProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <SecretInput
        isDisabled={isDisabled}
        isHidden={!isSetup}
        multiline={multiline}
        onChange={field.onChange}
        value={field.value}
        placeholder={placeholder?.toString()}
      />
    )}
  />
);
